var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
const DEFAULT_SIZE = 'regular';
export const SIZE_ALIAS = {
    BIG: 'big',
    REGULAR: 'regular',
    SMALL: 'small',
    TINY: 'tiny',
};
export const SIZE_TO_WAX = {
    [SIZE_ALIAS.BIG]: 'xl',
    [SIZE_ALIAS.REGULAR]: 'md',
    [SIZE_ALIAS.SMALL]: 'sm',
    [SIZE_ALIAS.TINY]: 'xs',
};
export const SIZES = {
    [SIZE_ALIAS.BIG]: 64,
    [SIZE_ALIAS.REGULAR]: 40,
    [SIZE_ALIAS.SMALL]: 32,
    [SIZE_ALIAS.TINY]: 28,
};
const withSize = (Component, defaultSize = DEFAULT_SIZE) => {
    return (_a) => {
        var { size = defaultSize } = _a, props = __rest(_a, ["size"]);
        const sizeValue = size in SIZES ? size : defaultSize;
        return React.createElement(Component, Object.assign({ size: sizeValue }, props));
    };
};
export default withSize;
//# sourceMappingURL=withSize.js.map